import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import JamieRsvp from "./components/JamieRsvp";
import Portfolio from "./components/Portfolio";
import Notebook from "./components/Notebook";
import My404Component from "./components/My404Component";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

// --- Original routes (temporarily disabled) ---
// import Home from "./components/Home";
// import Navigation from "./components/Navigation";
// import Projects from "./components/Projects";
// import Photos from "./components/Photography";
// import Contact from "./components/Contact";

const router = createBrowserRouter([
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/projects/notebook",
    element: <Notebook />,
  },
  {
    path: "/jamie",
    element: <JamieRsvp />,
  },
  {
    path: "*",
    element: <My404Component />,
  },
]);

ReactDOM.render(
  <React.StrictMode>
    <App>
      <RouterProvider router={router} />
    </App>
  </React.StrictMode>,
  document.getElementById("roota")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
